/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Subtext_Come_Up_EmptyInputs */



/**
* | output |
* | --- |
* | "Even the best collectors come up empty sometimes." |
*
* @param {Error_Notfound_Subtext_Come_Up_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_subtext_come_up_empty = /** @type {((inputs?: Error_Notfound_Subtext_Come_Up_EmptyInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Subtext_Come_Up_EmptyInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auch die besten Sammler gehen mal leer aus.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Même les meilleurs collectionneurs font chou blanc.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("再厉害的收藏家有时也会空手而归。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("再厲害的收藏家也有空手而回的時候。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("아무리 뛰어난 수집가도 빈손일 때가 있습니다.")
	return /** @type {LocalizedString} */ ("Even the best collectors come up empty sometimes.")
});